/**
 * Custom Tab Panel UI - Unico componente
 */
import * as React from 'react';
import PropTypes from 'prop-types';
import { Container, Box } from '@mui/material';

/**
 * @param {Number} index
 * @param {string} name
 * @returns Tabs ID and aria-control name
 */
export function a11yProps(index, name) {
  return {
    id: `${name}-tab-${index}`,
    'aria-controls': `${name}-tabpanel-${index}`,
  };
}

/**
 * Tab Panel generico
 * @param {object} props
 * @returns Multiple Tab Panel UI
 */
export function MultipleTabPanel(props) {
  const { children, value, index, padding = 2, name = 'multiple', ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`${name}-tabpanel-${index}`}
      aria-labelledby={`${name}-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: padding }}>
          <Container sx={{ p: '0', m: '0', maxWidth: '100% !important' }}>{children}</Container>
        </Box>
      )}
    </div>
  );
}

MultipleTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  padding: PropTypes.number,
  name: PropTypes.string,
};
